import React, { useState } from 'react';
import Button from '../Button/Button';
import Div from '../Element/Div/Div';
import Gutter from '../Gutter/Gutter';
import BodyText from '../Typography/BodyText/BodyText';
import InlineNotification from '../InlineNotification/InlineNotification';

import styles from './TupasLogin.module.scss';

type TupasLoginProps = {
  /** Login button label */
  loginButtonLabel: string;
  /** Login button onClick callback */
  onLoginButtonClick: () => void;
  /** Description for login type */
  description?: string;
  /** Highlighted Info text is shown below the login button */
  highlightedInfoText?: string;
};

const TupasLogin: React.FunctionComponent<TupasLoginProps> = ({
  loginButtonLabel,
  onLoginButtonClick,
  description,
  highlightedInfoText,
}) => {
  const [showInlineNotification, setShowInlineNotification] = useState(true);

  return (
    <Div padding={{ vertical: 'lg' }}>
      {description && (
        <>
          <BodyText>
            <Div
              data-testid="tupas-login-description-text"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          </BodyText>

          <Gutter size="md" />
        </>
      )}

      <Button
        data-testid="tupas-login-button"
        variant="primary"
        onClick={() => onLoginButtonClick()}
        size="md"
        iconName="chevron-right"
        iconOnRight={true}
      >
        {loginButtonLabel}
      </Button>

      {showInlineNotification && highlightedInfoText && (
        <>
          <Gutter size="lg" />

          <InlineNotification
            data-testid="tupas-login-highlighted-info-message"
            variant="information"
            closeOnClick={() => {
              setShowInlineNotification(false);
            }}
          >
            <Div
              className={styles.tupasLogin_inlineNotification}
              dangerouslySetInnerHTML={{
                __html: highlightedInfoText,
              }}
            />
          </InlineNotification>
        </>
      )}
    </Div>
  );
};

export default TupasLogin;
